"use client"

import { Transition } from "@headlessui/react"
import { useEffect, useState } from "react"

interface Props {
    sources?: string[]
    suppress?: boolean
}

export function SourcesFooter({ sources, suppress }: Props) {
    const [isExpanded, setIsExpanded] = useState(false)
    const [displayData, setDisplayData] = useState<
        Array<{
            favicon: string
            title: string
            url: string
        }>
    >([])

    useEffect(() => {
        if (sources && sources.length > 0) {
            const uniqueUrls = Array.from(new Set(sources))

            fetch("/labs/virtual-ray/sources", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ sources: uniqueUrls }),
            })
                .then((response) => response.json())
                .then((data) => {
                    setDisplayData(
                        (
                            data as Array<{
                                favicon: string
                                title: string
                                url: string
                            }>
                        ).slice(0, 5)
                    )
                })
        }
    }, [sources])

    if (sources == null || sources.length === 0) {
        return null
    }

    return (
        <Transition
            show={!suppress}
            enter="transition-all duration-500"
            enterFrom="max-h-0 opacity-0"
            enterTo="max-h-[20rem] opacity-100"
        >
            <div className="mt-2 flex flex-col gap-2">
                <Transition
                    as="div"
                    appear
                    enter="transition-opacity duration-500 delay-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                >
                    <button
                        type="button"
                        onClick={() => setIsExpanded((prev) => !prev)}
                        className="mx-4 flex items-center focus:outline-none"
                    >
                        <span className="font-semibold">Sources</span>
                        <span className="ml-1">{isExpanded ? "▼" : "►"}</span>
                    </button>
                </Transition>
                <Transition
                    as="div"
                    show={isExpanded}
                    enter="transition-all duration-500"
                    enterFrom="max-h-0 opacity-0"
                    enterTo="max-h-[24rem] opacity-100"
                >
                    <div className="mt-2 flex flex-col gap-2 px-4">
                        {displayData.map((source, index) => (
                            <div key={index} className="flex items-center gap-2">
                                <img src={source.favicon} alt="favicon" className="h-4 w-4" />
                                <a
                                    href={source.url}
                                    target="_blank"
                                    rel="noreferrer"
                                    className="truncate text-nowrap text-blue-600 underline"
                                >
                                    {source.title}
                                </a>
                            </div>
                        ))}
                    </div>
                </Transition>
            </div>
        </Transition>
    )
}
